import { useSupplierActions } from "../actions/supplierActions"
import { useSupplierBuilders } from "../builders/supplierBuilders"
import { useSupplierLoaders } from "../loaders/supplierLoaders"

export const useSupplierService = () => {
    const { buildSupplier } = useSupplierBuilders()
    
    const supplierLoaders = useSupplierLoaders()
    
    const { saveSupplier } = useSupplierActions()

    const archiveSupplier = async (supplierId: string) => {
        const { loadSupplier } = supplierLoaders()
        const supplier = await loadSupplier(supplierId, true)
        const archivedSupplier = buildSupplier({
            ...supplier,
            archived: true
        })
        return saveSupplier(archivedSupplier)
    }

    return {
        archiveSupplier
    }
}
